var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pageClasses,attrs:{"id":_vm.nameDashed}},[_c('oc-access-control',_vm._b({},'oc-access-control',_vm.$_accessControl,false),[_vm._t("default",[_c('oc-dynamic-structure',{attrs:{"schema":_vm.schema}})])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }